import {createContext} from 'react'
const BasicContext  = createContext()
export default BasicContext
